<div mat-dialog-title>
  <div class="d-flex justify-content-between" *ngIf="!isStdDCI">
      <p>Schedule Document</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
  <div class="d-flex justify-content-between" *ngIf="isStdDCI">
      <p>Standard Drawing</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content class="">
  <div class="row eip-pt-20 ml-0 mr-0">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="!isStdDCI">
          <mat-label class="font-weight-bold eip-mr-20">Numbering Format : </mat-label>
          <mat-button-toggle-group aria-label="Numbering Format" class="sche-semiauto" [(ngModel)]='numFormat' (change)="onValChange($event.value)">
              <mat-button-toggle value="Semi">Semi</mat-button-toggle>
              <mat-button-toggle value="Manual" *ngIf="canManualNo">Manual</mat-button-toggle>
              <mat-button-toggle value="Auto">Auto</mat-button-toggle>
          </mat-button-toggle-group>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12" *ngIf="isStdDCI" style="pointer-events: none;">
          <mat-label class="font-weight-bold eip-mr-20">Numbering Format : </mat-label>
          <mat-button-toggle-group aria-label="Numbering Format" class="sche-semiauto" [(ngModel)]='numFormat' (change)="onValChange($event.value)">
              <mat-button-toggle value="Semi">Semi</mat-button-toggle>
              <mat-button-toggle value="Auto">Auto</mat-button-toggle>
          </mat-button-toggle-group>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div class="d-flex justify-content-end">
              <div>
                  <p class="font-weight-bold eip-mr-10">No of Docs to Upload :</p>
              </div>
              <div class="sche-doc-no">
                  <input type="number" min="1" max="5" name="rateInput" [formControl]="rateControl" matInput placeholder="01">
                  <mat-error *ngIf="rateControl.value>5">
                      Maximum value is 5
                  </mat-error>
              </div>
              <div class=""> <i class="fa fa-arrow-right fs-24 eip-link sche-arrow " (click)="addDocument()" aria-hidden="true" id="btnCopy"></i>
              </div>
          </div>
      </div>
  </div>
  <ng-container *ngFor="let doc of noOfDocsArr;let i = index">
      <app-schedule-creation [docIndex]="i+1" [numFormat]='numFormat' (getDocumentSerialNo)="getDocumentSerialNo($event)" [autoSerialNoMap]="autoSerialNoMap" [sourceDciComponent]="sourceDciComponent" [isStdDCI]="isStdDCI" (getSourceDciComponent)="getSourceDciComponent()"></app-schedule-creation>
  </ng-container>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button class="btn btn-primary" id="btnSave" (click)="saveScheduleDoc(false)"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button>
      <button class="btn btn-primary" id="btnsaveAllDocument" (click)="saveScheduleDoc(true)"><i class="fa fa-save-as" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save
          & Add New</button>
      <button class="btn btn-secondary" id="btnReset" (click)="resetBulkSchedule();"><i class="fa fa-reset" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Reset</button>
  </div>
</div>